// Caches how many versions are tracked for a given org_component, so
// OrgComponentVersionsSection's skeleton renders the right number of
// placeholder rows immediately on repeat opens of the slide-over, instead of
// a generic guess. Written after every successful fetch of that
// org_component's versions; read synchronously at component setup time.
//
// Thin, page-specific wrapper around the generic cache — see
// composables/useSkeletonCountCache.js and docs/skeleton_count_caching.md.
import { getCachedSkeletonCount, setCachedSkeletonCount } from './useSkeletonCountCache'

const DEFAULT_COUNT = 2

export function getCachedOrgComponentVersionsCount(orgComponentId) {
  return getCachedSkeletonCount(`org_component_versions:${orgComponentId}`, DEFAULT_COUNT)
}

export function setCachedOrgComponentVersionsCount(orgComponentId, count) {
  setCachedSkeletonCount(`org_component_versions:${orgComponentId}`, count)
}
